export * from './header/header.component';
export * from './footer/footer.component';



// WEBPACK FOOTER //
// ./src/app/@theme/components/index.ts